import type { CSSProperties, ReactNode } from 'react'

/** text is 13px body; text2 is the 12px supporting size used under names and labels. */
export function Text({
  type = 'text',
  color,
  children,
  style,
}: {
  readonly type?: 'text' | 'text2'
  readonly color?: 'secondary'
  readonly children: ReactNode
  readonly style?: CSSProperties
}) {
  return (
    <span
      style={{
        fontSize: type === 'text2' ? 12 : 13,
        color: color === 'secondary' ? 'var(--fg-muted)' : 'var(--fg)',
        ...style,
      }}
    >
      {children}
    </span>
  )
}
